import React from 'react';
import { cn } from '@/lib/twUtils';

export interface CheckListProps {
  /** Nodi, non solo stringhe: una voce può chiudersi con un link */
  items: React.ReactNode[];
  /** `check` = elenco di ciò che c'è, `cross` = ciò che manca altrove */
  marker?: 'check' | 'cross' | 'dot';
  tone?: 'light' | 'dark';
  className?: string;
}

const markers = {
  check: { glyph: '✓', className: 'text-accent' },
  cross: { glyph: '✕', className: 'text-danger-500' },
  dot: { glyph: '', className: '' },
} as const;

/** Elenco puntato con simbolo coerente: spunte, croci o pallini. */
const CheckList = ({ items, marker = 'check', tone = 'light', className }: CheckListProps) => {
  const { glyph, className: markerClass } = markers[marker];

  return (
    <ul className={cn('flex flex-col gap-3.5', className)}>
      {items.map((item, index) => (
        <li
          key={index}
          className={cn(
            'flex gap-2.5 text-[0.90625rem] leading-[1.5]',
            tone === 'dark' ? 'text-white/60' : 'text-ink-strong'
          )}
        >
          {marker === 'dot' ? (
            <span aria-hidden className="mt-2 h-[5px] w-[5px] shrink-0 rounded-full bg-accent" />
          ) : (
            <span aria-hidden className={cn('shrink-0 font-bold', markerClass)}>
              {glyph}
            </span>
          )}
          {item}
        </li>
      ))}
    </ul>
  );
};

export default CheckList;
